/**
 * Customer Portal API
 * See `api-description.md` for detailed description.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UnauthorizedErrorAllOf } from './unauthorizedErrorAllOf';
import { ErrorWithoutCode } from './errorWithoutCode';


export interface UnauthorizedError { 
    /**
     * Enique error tracking identifier
     */
    id?: string;
    /**
     * Error code
     */
    code: string;
    /**
     * HTTP status code
     */
    status: number;
}

